export default [
  {
    path: "/product",
    component: (resolve) => require(["@/vuepage/product-manage/list.vue"], resolve),
    meta: [
      {
        name: "书斋管理",
      },
      {
        name: "商品列表",
        activeRoute: "/product",
      },
    ],
  },
  {
    path: "/product-add",
    component: (resolve) => require(["@/vuepage/product-manage/add.vue"], resolve),
    meta: [
      {
        name: "书斋管理",
      },
      {
        name: "新增商品",
        activeRoute: "/product",
      },
    ],
  },
  {
    path: "/product-type",
    component: (resolve) => require(["@/vuepage/product-manage/classification.vue"], resolve),
    meta: [
      {
        name: "书斋管理",
      },
      {
        name: "分类",
        activeRoute: "/product-type",
      },
    ],
  },
  {
    path: "/word",
    component: (resolve) => require(["@/vuepage/word-manage/list.vue"], resolve),
    meta: [
      {
        name: "敏感词库",
      },
      {
        name: "敏感词库",
        activeRoute: "/word",
      },
    ],
  },
  {
    path: "/word-list",
    component: (resolve) => require(["@/vuepage/word-manage/wordlist.vue"], resolve),
    meta: [
      {
        name: "敏感词库",
      },
      {
        name: "敏感词列表",
        activeRoute: "/word",
      },
    ],
  },
];
